<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card color="white">
        <v-form ref="PendingRemarksFormref" @submit.prevent>
          <v-card-title dark class="">
            <span>Add Pending Remarks</span>
            <v-spacer></v-spacer>
            <v-btn color="black" icon dark @click="close()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text style="max-height: 400px" class="my-2">
            <v-row>
              <v-col cols="12">
                <v-textarea
                  v-model="remarksMsg"
                  :rules="[formRules.required]"
                  dense
                  placeholder="Type here..."
                  outlined
                  rows="5"
                  required
                  class="rounded-lg"
                  color="#6DB249"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="close()"> cancel </v-btn>

            <v-btn
              color="green"
              :disabled="isSubmitLoading"
              :loading="isSubmitLoading"
              class="white--text"
              @click="handleSave()"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  props: {
    data: null,
    action: null,
    moduleFrom: null,
    type: null,
  },
  components: {},
  data() {
    return {
      dialog: false,
      remarksMsg: null,
      isSubmitLoading: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
    };
  },
  watch: {
    data: {
      handler(data) {
        if (data) {
          this.remarksMsg = null;
          this.dialog = true;
        }
      },
      immediate: true,
    },
  },
  methods: {
    close() {
      this.dialog = false;
      this.$emit("closeRemarks", null);
    },
    handleSave() {
      this.isSubmitLoading = true;
      if (this.$refs.PendingRemarksFormref.validate()) {
        let data = {
          module_from: this.moduleFrom,
          id_to_remark: this.data.id,
          type_of: this.type,
          message: this.remarksMsg,
        };

        this.axiosCall("/remarks/set-pending-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 201) {
              this.isSubmitLoading = false;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
              this.$emit("saveRemarks", res.data.data);
              this.dialog = false;
              // this.closeD();
            } else if (res.data.status == 400) {
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          }
        );
      }
    },
  },
};
</script>
